<div class="container py-5">
  <h1 class="mb-5">Account Settings</h1>

  <!-- PROFILE -->
  <div class="card mb-4">
    <div class="card-header">
      <h5 class="mb-0">Profile</h5>
    </div>
    <div class="card-body">
      <form [formGroup]="profileForm" novalidate>
        <div class="row">
          <div class="col-md-6 mb-3 form-group">
            <label for="profile_first_name">First Name <span class="text-danger">*</span></label>
            <input type="text" id="profile_first_name"
              class="form-control" [class.is-invalid]="isInvalid(profileForm, 'first_name')"
              formControlName="first_name" placeholder="Hans">
            <div class="invalid-feedback">First name is required.</div>
          </div>
          <div class="col-md-6 mb-3 form-group">
            <label for="profile_last_name">Last Name <span class="text-danger">*</span></label>
            <input type="text" id="profile_last_name"
              class="form-control" [class.is-invalid]="isInvalid(profileForm, 'last_name')"
              formControlName="last_name" placeholder="Müller">
            <div class="invalid-feedback">Last name is required.</div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 mb-3 form-group">
            <label for="profile_phone">Phone <span class="text-muted">(optional)</span></label>
            <input type="text" id="profile_phone" class="form-control"
              formControlName="phone" placeholder="+41 79 123 45 67">
          </div>
        </div>
        <button class="pw-btn pw-btn--primary" (click)="saveProfile()" [disabled]="isSavingProfile()">
          <span *ngIf="!isSavingProfile()">Save Profile</span>
          <div *ngIf="isSavingProfile()" class="spinner-border spinner-border-sm text-white" role="status"></div>
        </button>
      </form>
    </div>
  </div>

  <!-- PASSWORD -->
  <div class="card mb-4">
    <div class="card-header">
      <h5 class="mb-0">Change Password</h5>
    </div>
    <div class="card-body">
      <form [formGroup]="passwordForm" (ngSubmit)="changePassword()" novalidate data-testid="change-password-form">
        <div class="row">
          <div class="col-md-6 mb-3 form-group">
            <label for="current_password">Current Password <span class="text-danger">*</span></label>
            <input type="password" id="current_password" autocomplete="current-password"
              class="form-control" [class.is-invalid]="isInvalid(passwordForm, 'current_password') || passwordErrors().current_password"
              formControlName="current_password">
            <div class="invalid-feedback">{{ passwordErrors().current_password || 'Current password is required.' }}</div>
          </div>
        </div>
        <div class="row">
          <div class="col-md-6 mb-3 form-group">
            <label for="new_password">New Password <span class="text-danger">*</span></label>
            <input type="password" id="new_password" autocomplete="new-password"
              class="form-control" [class.is-invalid]="isInvalid(passwordForm, 'new_password') || passwordErrors().new_password"
              formControlName="new_password">
            <div class="invalid-feedback">{{ passwordErrors().new_password || passwordRule }}</div>
            <small *ngIf="!(isInvalid(passwordForm, 'new_password') || passwordErrors().new_password)"
              class="form-text text-muted">{{ passwordRule }}</small>
          </div>
          <div class="col-md-6 mb-3 form-group">
            <label for="confirm_password">Confirm New Password <span class="text-danger">*</span></label>
            <input type="password" id="confirm_password" autocomplete="new-password"
              class="form-control" [class.is-invalid]="confirmMismatch()"
              formControlName="confirm_password">
            <div class="invalid-feedback">Passwords do not match.</div>
          </div>
        </div>
        <button type="submit" class="pw-btn pw-btn--primary" [disabled]="isSavingPassword()">
          <span *ngIf="!isSavingPassword()">Change Password</span>
          <div *ngIf="isSavingPassword()" class="spinner-border spinner-border-sm text-white" role="status"></div>
        </button>
      </form>
    </div>
  </div>

  <!-- ORGANIZATION -->
  <div class="card">
    <div class="card-header">
      <h5 class="mb-0">Organization</h5>
    </div>
    <div class="card-body">
      <form [formGroup]="orgForm" novalidate>
        <div class="row">
          <div class="col-md-6 mb-3 form-group">
            <label for="org_company_name">Company Name <span class="text-muted">(optional)</span></label>
            <input type="text" id="org_company_name" class="form-control"
              formControlName="company_name" placeholder="Acme AG">
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 mb-3 form-group">
            <label for="org_first_name">First Name <span class="text-danger">*</span></label>
            <input type="text" id="org_first_name"
              class="form-control" [class.is-invalid]="isInvalid(orgForm, 'first_name')"
              formControlName="first_name" placeholder="Hans">
            <div class="invalid-feedback">First name is required.</div>
          </div>
          <div class="col-md-6 mb-3 form-group">
            <label for="org_last_name">Last Name <span class="text-danger">*</span></label>
            <input type="text" id="org_last_name"
              class="form-control" [class.is-invalid]="isInvalid(orgForm, 'last_name')"
              formControlName="last_name" placeholder="Müller">
            <div class="invalid-feedback">Last name is required.</div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 mb-3 form-group">
            <label for="org_email">Email <span class="text-danger">*</span></label>
            <input type="email" id="org_email"
              class="form-control" [class.is-invalid]="isInvalid(orgForm, 'email')"
              formControlName="email" placeholder="billing@acme.com">
            <div class="invalid-feedback">A valid email is required.</div>
          </div>
          <div class="col-md-6 mb-3 form-group">
            <label for="org_phone">Phone <span class="text-muted">(optional)</span></label>
            <input type="text" id="org_phone" class="form-control"
              formControlName="phone" placeholder="+41 44 123 45 67">
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 mb-3 form-group">
            <label for="org_address">Address <span class="text-muted">(optional)</span></label>
            <input type="text" id="org_address" class="form-control"
              formControlName="address" placeholder="Bahnhofstrasse 1">
          </div>
          <div class="col-md-3 mb-3 form-group">
            <label for="org_zip">ZIP <span class="text-muted">(optional)</span></label>
            <input type="text" id="org_zip" class="form-control"
              formControlName="zip" placeholder="8001">
          </div>
          <div class="col-md-3 mb-3 form-group">
            <label for="org_location">City <span class="text-muted">(optional)</span></label>
            <input type="text" id="org_location" class="form-control"
              formControlName="location" placeholder="Zürich">
          </div>
        </div>

        <div class="row">
          <div class="col-md-6 mb-3 form-group">
            <label for="org_country">Country <span class="text-muted">(optional)</span></label>
            <input type="text" id="org_country" class="form-control"
              formControlName="country" placeholder="Switzerland">
          </div>
        </div>

        <button class="pw-btn pw-btn--primary" (click)="saveOrganization()" [disabled]="isSavingOrg()">
          <span *ngIf="!isSavingOrg()">Save Organization</span>
          <div *ngIf="isSavingOrg()" class="spinner-border spinner-border-sm text-white" role="status"></div>
        </button>
      </form>
    </div>
  </div>
</div>
